Object.defineProperty(exports, '__esModule', {
  value: true
});
var get = require('lodash.get');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var get__default = /*#__PURE__*/_interopDefaultLegacy(get);
var test = function test(value, pattern) {
  var regExp = new RegExp(pattern);
  return regExp.test(value);
};
var validator = function validator(value, options) {
  if (!test(value, get__default['default'](options, "pattern"))) {
    return get__default['default'](options, "message");
  }
};
exports.test = test;
exports.validator = validator;